import React, { MouseEvent, useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import cx from 'classnames'
import { useWindowSize } from 'utils/hooks'
import { CalendarNavProps } from '../types'
import styles from '../Calendar.module.scss'
import dayjs from 'utils/dayjs'
import { MonthProps } from '~types'
import CalendarCaretDownIcon from '../../../../public/assets/calendar-caret-down-icon.svg'
import CalendarCaretUpIcon from '../../../../public/assets/calendar-caret-up-icon.svg'
import { DATE_FORMAT } from '~constants'

const CalendarFilter = ({ selectedMonth, handleMonthNavChange, activeMonthList }: CalendarNavProps) => {
  const parseDate = (dt: string, format: string) => dayjs(dt, 'MMM-YYYY').format(format)
  const [isNavOpen, showIsNavOpen] = useState(false)
  const toggleOptions = () => showIsNavOpen(!isNavOpen)
  const { isBreakpoint: isBelowBreakpointSm } = useWindowSize('sm', '<')
  const dropdownSelectedField = isBelowBreakpointSm ? 'shortLabel' : 'label'
  const monthOptions = activeMonthList.map(x => ({
    label: parseDate(x, DATE_FORMAT.MONTH_YEAR_LABEL),
    shortLabel: parseDate(x, `${DATE_FORMAT.SHORT_MONTH} ${DATE_FORMAT.SHORT_YEAR}`),
    value: parseDate(x, DATE_FORMAT.MONTH_YEAR_VALUE)
  }))

  const setActiveMonth = (event: MouseEvent<HTMLLIElement>) => {
    const text = (event.target as HTMLLIElement).innerText
    const [selectedMonth] = monthOptions.filter(month => month[dropdownSelectedField] === text)
    const parsedDate = dayjs(selectedMonth.label, DATE_FORMAT.MONTH_YEAR_LABEL)
    const currentMonth = dayjs(parsedDate).startOf('month')
    showIsNavOpen(false)
    handleMonthNavChange(selectedMonth)
  }

  const closeAllOptions = () => showIsNavOpen(false)

  return (
    <div className={styles['calendar-nav']}>
      <OutsideClickHandler
        onOutsideClick={() => {
          closeAllOptions()
        }}
      >
        <div className={styles['calendar-form-input']}>
          <div onClick={() => toggleOptions()} className={cx([styles['options-toggler']])}>
            {selectedMonth.label}
            <div className={styles['caret']}>{isNavOpen ? <CalendarCaretUpIcon /> : <CalendarCaretDownIcon />}</div>
          </div>
          {isNavOpen && monthOptions.length && (
            <div className={styles['options-container']}>
              <ul>
                {monthOptions.map((month: MonthProps, i: number) => (
                  <li
                    className={cx([
                      styles['option'],
                      styles[selectedMonth[dropdownSelectedField] == month[dropdownSelectedField] && 'active']
                    ])}
                    data-id={month.value}
                    key={i}
                    onClick={e => setActiveMonth(e)}
                  >
                    {month[dropdownSelectedField]}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </OutsideClickHandler>
    </div>
  )
}

export default CalendarFilter
